<div 
  class="so-switch-tile"
  [style.padding.px]="padding()"
  [class.dark]="darkMode()"
  [class.disabled]="effectiveDisabled()"
  [style.--so-switch-tile-bg]="tileBgCssVar()"
  [style.--so-switch-tile-border]="tileBorderCssVar()"
  [style.--so-switch-tile-title]="tileTitleCssVar()"
  [style.--so-switch-tile-subtitle]="tileSubtitleCssVar()"
  [attr.tabindex]="effectiveDisabled() ? -1 : 0"
  [attr.aria-disabled]="effectiveDisabled()"
  (click)="onTileClick()"
  (keydown)="onKeydown($event)">

  <!-- Icon section -->
  @if (icon()) {
    <div class="so-switch-tile__icon-wrapper">
      @if (iconType() === 'premium') {
        <so-premium-icon-ui
          [icon]="icon()"
          [color]="iconColor()"
          [size]="iconSize()"
          [padding]="premiumIconPadding()"
          [borderRadius]="iconBorderRadius()" />
      } @else {
        <div 
          class="so-switch-tile__icon-container"
          [style.width.px]="iconContainerSize()"
          [style.height.px]="iconContainerSize()"
          [style.border-radius.px]="iconBorderRadius()"
          [style.background-color]="effectiveDisabled() ? 'rgba(148, 163, 184, 0.1)' : iconBgColor()">
          <so-svg-icon-ui
            [name]="icon()"
            [size]="iconSize()"
            [color]="effectiveDisabled() ? '--so-gray-thick' : iconColor()">
          </so-svg-icon-ui>
        </div>
      }
    </div>
  }

  <!-- Content section -->
  <div class="so-switch-tile__content">
    <span 
      class="so-switch-tile__title">
      {{ title() }}
    </span>
    @if (subtitle()) {
      <span 
        class="so-switch-tile__subtitle">
        {{ subtitle() }}
      </span>
    }
  </div>

  <!-- Switch section -->
  <div class="so-switch-tile__switch" (click)="$event.stopPropagation()">
    <so-switch-ui
      [isChecked]="internalValue()"
      [isDisabled]="effectiveDisabled()"
      [activeColor]="activeColor()"
      [labels]="labels()"
      [labelLeft]="labelLeft()"
      [labelRight]="labelRight()"
      colorStyle="secondary"
      (statusChecked)="onSwitchChange($event)" />
  </div>
</div>
